<app-video-card *ngFor="let video of videos" [video]="video" (click)="onClickVideo(video)">
</app-video-card>
